<template>
  <v-card
    v-if="showUpdateNotification"
    class="update-notification-card"
    elevation="4"
    color="primary"
    dark
  >
    <v-card-text class="pa-4">
      <div class="d-flex align-center">
        <v-icon size="32" class="mr-3">mdi-update</v-icon>
        <div class="flex-grow-1">
          <div class="update-title">New Version Available</div>
          <div class="update-subtitle">
            {{ countdown > 0 ? `Updating in ${countdown} second${countdown !== 1 ? 's' : ''}...` : 'Updating now...' }}
          </div>
        </div>
        <v-progress-circular
          v-if="countdown > 0"
          :value="(countdown / initialCountdown) * 100"
          size="32"
          width="3"
          class="ml-3"
        ></v-progress-circular>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PWAUpdateNotification',
  data() {
    return {
      showUpdateNotification: false,
      countdown: 3,
      initialCountdown: 3,
      countdownInterval: null
    };
  },
  mounted() {
    // Listen for update events from the service
    if ('serviceWorker' in navigator) {
      console.log('PWAUpdateNotification: Setting up update listener');
      window.addEventListener('sw-update-available', this.handleUpdateAvailable);
      
      // Also check immediately if there's already a waiting service worker
      this.checkForWaitingWorker();
    }
  },
  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    window.removeEventListener('sw-update-available', this.handleUpdateAvailable);
  },
  methods: {
    async checkForWaitingWorker() {
      // Check if there's already a waiting service worker
      try {
        const registration = await navigator.serviceWorker.getRegistration();
        if (registration && registration.waiting) {
          console.log('PWAUpdateNotification: Found waiting service worker on mount');
          this.handleUpdateAvailable({
            detail: { registration }
          });
        }
      } catch (error) {
        console.error('Error checking for waiting worker:', error);
      }
    },
    async handleUpdateAvailable(event) {
      console.log('PWAUpdateNotification: Update available event received', event);
      
      if (this.showUpdateNotification) {
        console.log('PWAUpdateNotification: Already showing notification, skipping');
        return;
      }
      
      this.showUpdateNotification = true;
      this.countdown = this.initialCountdown;
      
      // Tell the waiting service worker to skip waiting
      if (event && event.detail && event.detail.registration) {
        const registration = event.detail.registration;
        if (registration.waiting) {
          try {
            console.log('PWAUpdateNotification: Sending SKIP_WAITING message to service worker');
            // Send message to waiting service worker
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          } catch (error) {
            console.error('Error sending skip waiting message:', error);
          }
        }
      }
      
      // Start countdown
      this.countdownInterval = setInterval(() => {
        this.countdown--;
        
        if (this.countdown <= 0) {
          clearInterval(this.countdownInterval);
          console.log('PWAUpdateNotification: Countdown complete, reloading app');
          this.reloadApp();
        }
      }, 1000);
    },
    reloadApp() {
      // Force a hard reload to get the new version
      console.log('PWAUpdateNotification: Reloading app');
      window.location.reload(true);
    }
  }
};
</script>

<style scoped>
.update-notification-card {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  max-width: 500px;
  width: calc(100% - 32px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

.update-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 4px;
}

.update-subtitle {
  font-size: 14px;
  opacity: 0.9;
  line-height: 1.3;
}

@media (max-width: 600px) {
  .update-notification-card {
    width: calc(100% - 16px);
    top: 8px;
  }
  
  .update-title {
    font-size: 16px;
  }
  
  .update-subtitle {
    font-size: 13px;
  }
}
</style>
